VjsAdmin.DistrictSearchSelect = (() => {
    const me = {
        filterData: [],
    };

    const init = (parent = document.querySelector('body'), filterData = []) => {
        if (filterData.length > 0) {
            me.filterData = filterData.filter((item) => !item.license_id).map((item) => parseInt(item.district_id, 10));
        }

        const districtSelect2 = $('#district-search-select2');
        if (districtSelect2.hasClass('select2-hidden-accessible')) {
            return;
        }

        districtSelect2.select2({
            ajax: {
                type: 'POST',
                url: Slim.Router.pathFor('districts.vjs.list.json'),
                dataType: 'json',
                delay: 250,
                data(params) {
                    return {
                        search_term: params.term,
                    };
                },
                processResults(data) {
                    let newItems = data.data.map((item) => ({
                        id: item.district_id,
                        text: `${item.district_name} : ${item.district_id}`,
                    }));

                    if (me.filterData.length > 0) {
                        newItems = newItems.filter((item) => !me.filterData.includes(item.id));
                    }

                    return {
                        results: newItems,
                        pagination: {
                            more: false,
                        },
                    };
                },
            },
            placeholder: 'Search for a district',
            minimumInputLength: 3,
            theme: 'bootstrap4',
            dropdownParent: parent,
        });
    };

    return {
        init,
    };
})();
